
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/home/canvas/public-html/ui/features/assignment-index/jst/AssignmentGroupList';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  return "\n  <ul class='collectionViewItems ig-list'></ul>\n";
  }

function program3(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.firstResetLanded), {hash:{},inverse:self.program(6, program6, data),fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <ul class='collectionViewItems ig-list'>\n      <li>\n        <div class='ig-row ig-row-empty'>\n          <div class='ig-empty-msg'>\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.assignment_group_list")
  },data:data},helper ? helper.call(depth0, "assignments.assignment_group_list.no_assignment_groups", "No Assignment Groups found", options) : helperMissing.call(depth0, "t", "assignments.assignment_group_list.no_assignment_groups", "No Assignment Groups found", options)))
    + "\n          </div>\n        </div>\n      </li>\n    </ul>\n  ";
  return buffer;
  }

function program6(depth0,data) {
  
  
  return "\n    <div class='loadingIndicator'></div>\n  ";
  }

  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.collection)),stack1 == null || stack1 === false ? stack1 : stack1.length), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { return stack1; }
  else { return ''; }
  });
    ;
    ;
    export default templates[name];
  